import { render } from "./ErrorBar.vue?vue&type=template&id=37366690"
import script from "./ErrorBar.vue?vue&type=script&lang=js"
export * from "./ErrorBar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__